// Impagina il contenuto in fogli A4 reali: stessi fogli in anteprima e nel PDF (nessun elemento tagliato).
// data-pg="split" = contenitore divisibile (i figli vanno a capo singolarmente); data-pg="firma" = sempre in fondo all'ultimo foglio.
const SAFETY = 20;
const isKeep = (n) => /^(H1|H2|H3|H4|THEAD)$/.test(n.tagName) || n.dataset.pg === "keep";

export function impaginaA4(src, out) {
  out.innerHTML = "";
  const created = new Map();
  let cur = null;
  let last = null;
  const newPage = () => {
    const p = document.createElement("div");
    p.className = "a4-pagina";
    const c = document.createElement("div");
    c.className = "a4-contenuto";
    p.appendChild(c);
    out.appendChild(p);
    const st = getComputedStyle(p);
    const cap = p.clientHeight - parseFloat(st.paddingTop) - parseFloat(st.paddingBottom);
    cur = { page: p, content: c, chain: [], atoms: 0, cap };
  };
  const overflow = () => cur.content.offsetHeight > cur.cap - SAFETY;
  const prune = () => {
    for (let i = cur.chain.length - 1; i >= 0; i--) {
      const cl = cur.chain[i].clone;
      const kids = Array.from(cl.children).filter((k) => k.tagName !== "THEAD");
      if (kids.length) break;
      cl.remove();
      cur.chain.length = i;
    }
  };
  const ensure = (anc) => {
    let i = 0;
    while (i < cur.chain.length && i < anc.length && cur.chain[i].src === anc[i]) i++;
    cur.chain.length = i;
    let parent = i ? cur.chain[i - 1].clone : cur.content;
    for (let j = i; j < anc.length; j++) {
      const s = anc[j];
      const cl = s.cloneNode(false);
      const n = created.get(s) || 0;
      if (n > 0 && s.tagName === "TABLE") {
        const th = Array.from(s.children).find((k) => k.tagName === "THEAD");
        if (th) cl.appendChild(th.cloneNode(true));
      }
      created.set(s, n + 1);
      parent.appendChild(cl);
      cur.chain.push({ src: s, clone: cl });
      parent = cl;
    }
    return parent;
  };
  const put = (node, anc, cl) => { ensure(anc).appendChild(cl); cur.atoms++; };
  const place = (node, anc) => {
    if (node.nodeType !== 1) return;
    if (node.dataset.pg === "split") {
      Array.from(node.children).forEach((ch) => place(ch, [...anc, node]));
      return;
    }
    if (node.dataset.pg === "firma") {
      const cl = node.cloneNode(true);
      put(node, [], cl);
      if (overflow() && cur.atoms > 1) { cl.remove(); newPage(); put(node, [], cl); }
      const free = cur.cap - SAFETY - cur.content.offsetHeight;
      if (free > 0) {
        const sp = document.createElement("div");
        sp.style.height = `${free}px`;
        cl.before(sp);
      }
      last = null;
      return;
    }
    const cl = node.cloneNode(true);
    put(node, anc, cl);
    if (overflow() && cur.atoms === 1 && node.children.length > 1) {
      // Blocco più alto di un foglio: lo divido nei suoi elementi interni invece di tagliarlo.
      cl.remove(); cur.atoms--; prune();
      Array.from(node.children).forEach((ch) => place(ch, [...anc, node]));
      return;
    }
    if (overflow() && cur.atoms > 1) {
      cl.remove();
      const moveKeep = last && last.keep && last.page === cur.page && cur.atoms > 2;
      if (moveKeep) last.clone.remove();
      prune();
      newPage();
      if (moveKeep && last.node.tagName !== "THEAD") put(last.node, last.anc, last.clone);
      put(node, anc, cl);
    }
    last = { node, anc, clone: cl, keep: isKeep(node), page: cur.page };
  };
  newPage();
  Array.from(src.children).forEach((ch) => place(ch, []));
  const pages = Array.from(out.children);
  pages.forEach((p, i) => {
    const n = document.createElement("div");
    n.className = "a4-num";
    n.textContent = `Pagina ${i + 1} di ${pages.length}`;
    p.appendChild(n);
  });
  return pages.length;
}

export const CSS_FOGLI_A4 = `
.a4-pagine{display:flex;flex-direction:column;align-items:center;gap:18px;padding:8px 0 24px}
.a4-pagina{width:210mm;height:296.5mm;background:#fff;box-shadow:0 10px 30px rgba(0,0,0,.18);padding:10mm 0 12mm;box-sizing:border-box;position:relative;overflow:hidden}
.a4-contenuto{display:flow-root}
.a4-num{position:absolute;bottom:4mm;right:12mm;font-size:8px;color:#a1a1aa;letter-spacing:.05em}
`;
